import { useTranslation } from "react-i18next";
import { ArrowRight, AlertTriangle } from "lucide-react";
import { NeuButton, NeuCard } from "../neu/Neu";

// قوقعة نموذج بصفحة كاملة: رأس + سهم رجوع + شريط أفعال سفلي ثابت + تلميح تحقّق.
export const FormPageShell = ({ title, subtitle, onBack, children, onCancel, onSubmit,
                                submitLabel, busy, disabled, hint, testid = "form-page" }) => {
  const { t } = useTranslation();

  return (
    <div className="grid gap-4 pb-28" data-testid={testid}>
      <div className="flex items-center gap-3">
        <button type="button" data-testid={`${testid}-back`} onClick={onBack}
                className="rounded-xl p-2 shadow-neu-sm text-muted-foreground hover:text-primary">
          <ArrowRight className="h-4 w-4 rtl:rotate-0 ltr:rotate-180" />
        </button>
        <div className="min-w-0">
          <p className="truncate text-base font-bold md:text-lg">{title}</p>
          {subtitle ? <p className="truncate text-xs text-muted-foreground">{subtitle}</p> : null}
        </div>
      </div>

      <NeuCard className="grid gap-4 p-5">{children}</NeuCard>

      <div className="fixed inset-x-0 bottom-0 z-40 flex flex-wrap items-center justify-center gap-3 border-t border-border/60 bg-background/95 px-4 py-3 backdrop-blur sm:justify-end sm:px-8 lg:px-12"
           data-testid={`${testid}-bar`}>
        {hint && disabled ? (
          <div data-testid={`${testid}-hint`}
               className="flex items-center gap-2 rounded-xl bg-amber-100 px-3 py-2 text-[11px] font-bold text-amber-900 dark:bg-amber-900/30 dark:text-amber-100">
            <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
            <span>{hint}</span>
          </div>
        ) : null}
        <NeuButton className="px-5 py-3 text-xs" data-testid={`${testid}-cancel`} onClick={onCancel}>
          {t("app.cancel")}
        </NeuButton>
        <NeuButton variant="primary" className="px-6 py-3 text-xs" disabled={busy || disabled}
                   title={disabled && hint ? hint : undefined}
                   data-testid={`${testid}-submit`} onClick={onSubmit}>
          {submitLabel || t("app.save")}
        </NeuButton>
      </div>
    </div>
  );
};
